
      import '../src/css/base.css';

      document.addEventListener('DOMContentLoaded', async () => {
        const res = await fetch('./games.json');
        // mtn-vista-v1.2.glb
        const examples = await res.json();
        console.log('examples', examples);
        const dev = document.querySelector('#game-list');
        if (examples?.games?.length && dev) {
          const games = document.createElement('ul');
          examples.games.forEach(game => {
            const gameItem = document.createElement('li');
            const gameItemLink = document.createElement('a');
            let uri = game.url;
            if (game.courseUrl) {
              uri += '?' + new URLSearchParams({ courseUrl: game.courseUrl});
            }
            const gameItemPoster = document.createElement('img');
            gameItemPoster.width = 160;
            gameItemPoster.height = 90;
            gameItemPoster.src = game.posterUrl;
            
            const gameItemTitle = document.createElement('div');
            gameItemTitle.textContent = game.title;
            gameItemLink.append(gameItemPoster, gameItemTitle);

            // gameItemLink.textContent = game.title;

            gameItemLink.setAttribute('href', uri);
            gameItem.append(gameItemLink);
            games.append(gameItem);
          });
          dev.append(games);
        }
      });
    